export const CANCELLATIONS = 'CANCELLATIONS'
export const CANCELLATIONS_SUMMARY = 'CANCELLATIONS_SUMMARY'
export const CANCELLATIONS_SUMMARY_REASONS = 'CANCELLATIONS_SUMMARY_REASONS'
export const CANCELLATION = 'CANCELLATION'
export const CANCELLATION_UPDATE = 'CANCELLATION_UPDATE'

export default {
    CANCELLATIONS,
    CANCELLATIONS_SUMMARY,
    CANCELLATIONS_SUMMARY_REASONS,
    CANCELLATION,
    CANCELLATION_UPDATE
}
